import { CSSProperties } from "react";
import { styled } from "styled-components";
import { colors } from "./colors";

export type TextStyles = {
  h1: CSSProperties;
  h2: CSSProperties;
  h3: CSSProperties;
  h4: CSSProperties;
  body: CSSProperties;
  small: CSSProperties;
  smallCondensed: CSSProperties;
  mini: CSSProperties;
  button: CSSProperties;
  numbers: CSSProperties;
};

const LORA = "Lora";
const UBUNTU = "Ubuntu";

export const H1 = styled.h1`
  font-family: ${LORA};
  font-size: 28px;
  font-weight: bold;
  line-height: 34px;
  font-weight: bold;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const H2 = styled.h2`
  font-family: ${LORA};
  font-size: 24px;
  font-weight: 500;
  line-height: 34px;
  font-style: normal;
  letter-spacing: 2%;
  color: ${colors.dark};
`;

export const H3 = styled.h3`
  font-family: ${UBUNTU};
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  font-style: normal;
  letter-spacing: 2%;
  color: ${colors.dark};
`;

export const H4 = styled.h4`
  font-family: ${UBUNTU};
  font-size: 16px;
  font-weight: 500;
  line-height: 26px;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const H5 = styled.h4`
  font-family: ${UBUNTU};
  font-size: 16px;
  font-weight: 400;
  line-height: 26px;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const Body = styled.p`
  font-family: ${UBUNTU};
  font-size: 15px;
  line-height: 26px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;
export const Body60 = styled(Body)`
  opacity: 0.6;
`;

export const Small = styled.p`
  font-family: ${UBUNTU};
  font-size: 14px;
  line-height: 20px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.medium};
`;

export const Mini = styled.p`
  font-family: ${UBUNTU};
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const ButtonText = styled.p`
  font-family: ${UBUNTU};
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;

export const TextButtonText = styled.p`
  /* Button TextOnly */
  font-family: ${UBUNTU};
  font-size: 15px;
  font-weight: 500;
  line-height: 20px;
  font-style: normal;
  letter-spacing: 0;
  color: ${colors.dark};
`;
